module.exports = __webpack_public_path__ + "img/sprite-1.2c4f60f2.webp";